import React, { useEffect, useState } from 'react';
import { getUserStats, UserStats } from '../services/api';
import './Progress.css';

const Progress: React.FC = () => {
  const [stats, setStats] = useState<UserStats | null>(null);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const data = await getUserStats();
        setStats(data);
      } catch (err) {
        console.error('Failed to load stats:', err);
      }
    };
    loadStats();
  }, []);

  if (!stats) {
    return <div className="loading">Ładowanie...</div>;
  }

  return (
    <div className="progress-page fade-in">
      <h1>📊 Twoje postępy</h1>

      <div className="stats-grid">
        <div className="big-stat-card points">
          <span className="big-stat-icon">⭐</span>
          <span className="big-stat-value">{stats.totalPoints}</span>
          <span className="big-stat-label">Punktów łącznie</span>
        </div>

        <div className="big-stat-card streak">
          <span className="big-stat-icon">🔥</span>
          <span className="big-stat-value">{stats.currentStreak}</span>
          <span className="big-stat-label">Dni z rzędu</span>
        </div>

        <div className="big-stat-card words">
          <span className="big-stat-icon">📖</span>
          <span className="big-stat-value">{stats.wordsLearned}</span>
          <span className="big-stat-label">Słówek opanowanych</span>
        </div>

        <div className="big-stat-card lessons">
          <span className="big-stat-icon">📚</span>
          <span className="big-stat-value">{stats.lessonsCompleted}</span>
          <span className="big-stat-label">Lekcji ukończonych</span>
        </div>
      </div>

      <div className="card today-card">
        <h3>📅 Dzisiaj zdobyłeś</h3>
        <div className="today-points">{stats.todayPoints} punktów</div>
      </div>

      <div className="card tips-card">
        <h3>💡 Wskazówki</h3>
        <ul>
          <li>Ucz się codziennie, aby utrzymać passę! 🔥</li>
          <li>Powtarzaj słówka regularnie 🔄</li>
          <li>Graj w gry, aby lepiej zapamiętać 🎮</li>
        </ul>
      </div>
    </div>
  );
};

export default Progress;

